"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["children", "className", "isNormalName", "isLetters", "isAbbreviated", "isNormalAbbreviatedStyle", "isNormalLettersStyle"];

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  max-width: 100%;\n  hyphens: auto;\n  word-wrap: break-word;\n"])));

var teams = {
  "West Bromwich Albion": "West Brom",
  "Manchester City": "Man City",
  "Tottenham Hotspur": "Tottenham",
  "Manchester United": "Man Utd",
  "Brighton and Hove Albion": "Brighton",
  "Wolverhampton Wanderers": "Wolves",
  "Borussia Dortmund": "Dortmund",
  "Sheffield Wednesday": "Sheff Wed",
  "Sheffield United": "Sheff Utd",
  "Queens Park Rangers": "QPR",
  "Paris Saint-Germain": "PSG",
  Indians: "Guardians"
};

var getAbbreviated = function getAbbreviated(name, isNormalAbbreviatedStyle) {
  if (isNormalAbbreviatedStyle) {
    return name;
  }

  name = name.replace(/\./g, "");
  name = name.replace(" de", "");
  name = name.replace("Nottingham", "Notts");
  name = name.replace(" North End", "");
  name = name.replace(" Argyle", "");
  name = name.replace(" Caledonian Thistle", "");
  name = name.replace(" Thistle", ""); // try get friendly name from our list

  if (teams[name]) {
    name = teams[name];
  } else {
    // remove City, United, Athletic, Rovers etc
    name = name.replace(" Athletic", "");

    if (name.includes("United")) {
      if (!name.includes("Manchester") && !name.includes("Dundee")) {
        name = name.replace(" United", "");
      } else {
        name = name.replace("United", "Utd");
      }
    } else if (name.includes("City")) {
      if (!name.includes("Manchester") && !name.includes("Bristol")) {
        name = name.replace(" City", "");
      }
    } else if (name.includes("Rovers")) {
      if (!name.includes("Bristol")) {
        name = name.replace(" Rovers", "");
      }
    } else if (name.includes("Town")) {
      name = name.replace(" Town", "");
    } else if (name.includes("County")) {
      if (!name.includes("Notts") && !name.includes("Ross")) {
        name = name.replace(" County", "");
      }
    } else if (name.includes("FC")) {
      name = name.replace(" FC", "");
    }
  }

  return name;
};

var getLetters = function getLetters(name, isNormalLettersStyle) {
  // bespoke ncaa letters
  if (name === "Florida Gators") {
    return "FLA";
  } else if (name === "New Orleans Privateers") {
    return "UNO";
  } else if (name === "Ole Miss Rebels") {
    return "MISS";
  } else if (name === "Texas A&M Aggies") {
    return "A&M";
  } else if (name === "Missouri Tigers") {
    return "MIZ";
  } else if (name === "Mississippi State Bulldogs") {
    return "MST";
  } else if (name === "Kansas State Wildcats") {
    return "KST";
  } else if (name === "Oklahoma Sooners") {
    return "OU";
  } else if (name === "West Virginia Mountaineers") {
    return "WVU";
  } else if (name === "Oklahoma State Cowboys") {
    return "OKST";
  } else if (name === "Kansas Jayhawks") {
    return "KU";
  } else if (name === "Iowa State Cyclones") {
    return "ISU";
  } else if (name === "Texas Tech Red Raiders") {
    return "TTU";
  } else if (name === "Kansas State Wildcats") {
    return "KSU";
  } else if (name === "Duke Blue Devils") {
    return "DU";
  } else if (name === "North Carolina Tar Heels") {
    return "UNC";
  } else if (name === "Florida State Seminoles") {
    return "FSU";
  } else if (name === "North Carolina State Wolfpack") {
    return "NCS";
  } else if (name === "Virginia Tech") {
    return "VT";
  } else if (name === "Texas A&M") {
    return "A&M";
  } else if (name === "Auburn") {
    return "AUB";
  } else if (name === "UCLA Bruins") {
    return "UCLA";
  } else if (name === "UCLA") {
    return "UCLA";
  } else if (name === "Oklahoma Sooners Softball") {
    return "OU";
  } else if (name === "Oklahoma State") {
    return "OSU";
  } else if (name === "Kansas State") {
    return "KSU";
  } else if (name === "Western Kentucky") {
    return "WKU";
  } else if (name === "Washington State Cougars") {
    return "WSU";
  } // bespoke soccer letters


  if (name === "Manchester United") {
    return "MNU";
  } else if (name === "Manchester City") {
    return "MNC";
  } // bespoke NFL letters


  if (name === "Green Bay Packers") {
    return "GB";
  } else if (name === "Kansas City Chiefs") {
    return "KC";
  } else if (name === "Las Vegas Raiders") {
    return "LV";
  } else if (name === "Los Angeles Chargers") {
    return "LAC";
  } else if (name === "Los Angeles Rams") {
    return "LAR";
  } else if (name === "New England Patriots") {
    return "NE";
  } else if (name === "New Orleans Saints") {
    return "NO";
  } else if (name === "New York Giants") {
    return "NYG";
  } else if (name === "New York Jets") {
    return "NYJ";
  } else if (name === "San Francisco 49ers") {
    return "SF";
  } else if (name === "Tampa Bay Buccaneers") {
    return "TB";
  } //bespoke Baseball letters


  if (name === "Chicago White Sox" || name === "White Sox") {
    return "CWS";
  } else if (name === "Cleveland Indians" || name === "Indians" || name === "Clevaland Guardians" || name === "Guardians") {
    return "CLE";
  } //bespoke Dutch letters


  if (name === "Ajax") {
    return "AJA";
  } else if (name === "AZ" || name === "AZ Alkmaar") {
    return "AZ";
  } else if (name === "SC Cambuur" || name === "Cambuur") {
    return "CAM";
  } else if (name === "Feyenoord") {
    return "FEY";
  } else if (name === "Fortuna Sittard") {
    return "FOR";
  } else if (name === "Go Ahead Eagles" || name === "G.A. Eagles") {
    return "GAE";
  } else if (name === "FC Groningen" || name === "Groningen") {
    return "FCG";
  } else if (name === "sc Heerenveen" || name === "Heerenveen") {
    return "HEE";
  } else if (name === "Heracles Almelo") {
    return "HER";
  } else if (name === "N.E.C.") {
    return "NEC";
  } else if (name === "PEC Zwolle" || name === "Zwolle") {
    return "PEC";
  } else if (name === "PSV") {
    return "PSV";
  } else if (name === "RKC Waalwijk" || name === "Waalwijk") {
    return "RKC";
  } else if (name === "Sparta Rotterdam") {
    return "SPA";
  } else if (name === "FC Twente" || name === "Twente") {
    return "FCT";
  } else if (name === "FC Utrecht" || name === "Ultrecht") {
    return "FCU";
  } else if (name === "Vitesse") {
    return "VIT";
  } else if (name === "Willem II") {
    return "WIL";
  }

  name = name.replace(" Thistle", "").replace(/\./g, "").replace("SC", "").replace("AC", "").replace("AFC", "").replace("FC", "").replace("SC ", "").replace("SV ", "").replace("Real ", "").replace("de ", "").replace("Borussia ", "").replace("Net", "NED");
  console.log("isNormalLettersStyle", isNormalLettersStyle);

  if (name.length > 10 && !isNormalLettersStyle) {
    var words = name.split(" ");

    var _iterator = _createForOfIteratorHelper(words),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var w = _step.value;

        if (w.includes("-")) {
          words.splice(words.indexOf(w), 1);
          var split = w.split("-");
          words = [].concat(_toConsumableArray(words), _toConsumableArray(split));
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (words.length === 3) {
      name = words[0].substr(0, 1) + words[1].substr(0, 1) + words[2].substr(0, 1);
    }
  }

  return name.replace(" ", "").substr(0, 3).toUpperCase();
};

var Wrapper = function Wrapper(_ref) {
  var children = _ref.children,
      className = _ref.className,
      isNormalName = _ref.isNormalName,
      isLetters = _ref.isLetters,
      isAbbreviated = _ref.isAbbreviated,
      isNormalAbbreviatedStyle = _ref.isNormalAbbreviatedStyle,
      isNormalLettersStyle = _ref.isNormalLettersStyle,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      name = _useState2[0],
      setName = _useState2[1];

  (0, _react.useEffect)(function () {
    if (children) {
      if (isAbbreviated) {
        setName(getAbbreviated(children, isNormalAbbreviatedStyle));
      } else if (isLetters) {
        setName(getLetters(children, isNormalLettersStyle));
      } else {
        setName(children);
      }
    }
  }, [children]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, _objectSpread(_objectSpread({
    className: className
  }, rest), {}, {
    children: name
  }));
};

var _default = Wrapper;
exports.default = _default;